(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["esteem-bogo-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('esteem-bogo-offer')) {
    customElements.define('esteem-bogo-offer', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.labels = { ...this.dataset };
        this.code = this.dataset.code;
        this.variants = new Set(this.dataset.variants.split(','));
        this.container = this.closest('[data-section-type="product"]');
        this.events = new AbortController();
        this.refresh = this.refresh.bind(this);
        this.apply = this.apply.bind(this);
        this.onVariant = (event) => {
          const variant = event.detail.variant;
          this.hidden = !variant || !variant.available ||
            !(this.dataset.allVariants === 'true' || this.variants.has(String(variant.id)));
        };
        this.button.addEventListener('click', this.apply, { signal: this.events.signal });
        this.container?.addEventListener('theme:variant:change', this.onVariant, { signal: this.events.signal });
        document.addEventListener('theme:cart:change', this.refresh, { signal: this.events.signal });
        window.addEventListener('pageshow', this.refresh, { signal: this.events.signal });
        this.refresh();
      }
      disconnectedCallback() { this.events?.abort(); this.request?.abort(); }
      async cart(path, body) {
        const response = await fetch((window.Shopify?.routes?.root || '/') + path, {
          method: body ? 'POST' : 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          ...(body ? { body: JSON.stringify(body) } : {}),
          signal: AbortSignal.timeout(10000)
        });
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      }
      render(cart) {
        const code = (cart.discount_codes || []).find(entry => entry.code.toUpperCase() === this.code.toUpperCase());
        this.dataset.state = code ? 'selected' : 'idle';
        this.button.textContent = code ? (code.applicable ? this.labels.applied : this.labels.selected) : this.labels.apply;
        this.status.textContent = code ? (code.applicable ? this.labels.success : this.labels.ready) : this.labels.terms;
      }
      async refresh() {
        if (this.busy) return;
        const revision = this.revision || 0;
        try {
          const cart = await this.cart('cart.js');
          if (this.isConnected && !this.busy && revision === (this.revision || 0)) this.render(cart);
        } catch {}
      }
      async apply() {
        if (this.busy) return;
        this.busy = true;
        this.revision = (this.revision || 0) + 1;
        this.button.disabled = true;
        this.button.textContent = this.labels.saving;
        this.setAttribute('aria-busy', 'true');
        const blockPurchase = (event) => {
          if (event.target.closest('[data-add-to-cart], .shopify-payment-button')) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        };
        document.addEventListener('click', blockPurchase, true);
        try {
          const current = await this.cart('cart.js');
          const codes = (current.discount_codes || []).map(entry => entry.code);
          if (!codes.some(code => code.toUpperCase() === this.code.toUpperCase())) codes.push(this.code);
          const updated = await this.cart('cart/update.js', { discount: codes.join(',') });
          if (!(updated.discount_codes || []).some(entry => entry.code.toUpperCase() === this.code.toUpperCase())) throw new Error('Code was not saved');
          this.render(updated);
          if (updated.item_count > 0) document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        } catch {
          this.button.textContent = this.labels.apply;
          this.status.textContent = this.labels.error;
          this.dataset.state = 'idle';
        } finally {
          this.busy = false;
          this.button.disabled = false;
          this.removeAttribute('aria-busy');
          document.removeEventListener('click', blockPurchase, true);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esteem-editorial-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('esteem-editorial-guide')){
customElements.define('esteem-editorial-guide',class extends HTMLElement{
connectedCallback(){
if(this.dataset.ready)return;
const body=this.querySelector('.esteem-guide__body');
if(!body)return;
body.querySelectorAll('table').forEach(table=>{const wrap=document.createElement('div');wrap.className='esteem-guide__table';wrap.tabIndex=0;table.before(wrap);wrap.append(table);});
this.dataset.ready='true';
const nodes=Array.from(body.childNodes);
let intro=document.createElement('div');
intro.className='esteem-guide__intro';
body.append(intro);
let destination=intro;
nodes.forEach(node=>{
if(node.nodeType===1&&node.tagName==='H2'){
const chapter=document.createElement('section');
chapter.className='esteem-guide__chapter';
const content=document.createElement('div');
content.className='esteem-guide__chapter-content';
chapter.append(node,content);
body.append(chapter);
destination=content;
const title=node.textContent.trim();
if(title==='Best Esteem Apparel Options by Goal'||title==='Best Esteem Apparel Options by Need'||title==='Compression Undershirt vs Tank vs Binder')chapter.classList.add('esteem-guide__chapter--cards');
if(title==='Final Thoughts'||title==='The bottom line')chapter.classList.add('esteem-guide__chapter--final');
}else destination.append(node);
});
body.querySelectorAll('p').forEach(p=>{if(!p.textContent.trim()&&!p.querySelector('img,video,iframe'))p.remove();});
body.querySelectorAll('.esteem-guide__chapter').forEach(chapter=>{
const title=chapter.querySelector('h2').textContent.trim();
if(chapter.classList.contains('esteem-guide__chapter--cards'))chapter.querySelectorAll('ul').forEach(ul=>ul.classList.add('guide-cards'));
if(title==='Key Benefits of Gynecomastia Compression Shirts'||title==='Spanx for Men vs Esteem Apparel')chapter.querySelectorAll('ul').forEach(ul=>ul.classList.add('guide-benefits'));
if(title==='What Actually Matters When Choosing a Compression Shirt'||title==='What Actually Matters Before You Buy')chapter.querySelectorAll('p').forEach(p=>{if(p.querySelector('strong'))p.classList.add('guide-factor');});
});
body.querySelectorAll('div[style]').forEach(div=>{if(div.querySelector('a[style]')){div.classList.add('guide-cta');div.querySelectorAll(':scope > br').forEach(br=>br.remove());}});
}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esteem-pack-value"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('esteem-pack-value'))customElements.define('esteem-pack-value',class extends HTMLElement{
connectedCallback(){
this.events=new AbortController();
this.closest('[data-section-type="product"]')?.addEventListener('theme:variant:change',event=>{
const id=String(event.detail.variant?.id||'');let found=false;
this.querySelectorAll('[data-pack-id]').forEach(panel=>{panel.hidden=panel.dataset.packId!==id;if(!panel.hidden)found=true;});this.hidden=!found;
},{signal:this.events.signal});
if(!this.querySelector('[data-pack-id]:not([hidden])'))this.hidden=true;
}
disconnectedCallback(){this.events?.abort();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esteem-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('esteem-product-details')) {
    customElements.define('esteem-product-details', class extends HTMLElement {
      connectedCallback() {
        if (!this.enhanced) {
          this.enhanced = true;
          const nodes = Array.from(this.childNodes);
          const headings = nodes.filter(node => node.nodeType === 1 && /^(H2|H3)$/.test(node.tagName));
          if (headings.length) {
            const output = document.createDocumentFragment();
            const intro = document.createElement('div');
            intro.className = 'esteem-details__intro';
            output.append(intro);
            let body = intro;
            nodes.forEach(node => {
              if (headings.includes(node)) {
                const details = document.createElement('details');
                details.className = 'esteem-details__section';
                const summary = document.createElement('summary');
                summary.append(node);
                body = document.createElement('div');
                body.className = 'esteem-details__body';
                details.append(summary, body);
                output.append(details);
              } else {
                body.append(node);
              }
            });
            if (!intro.textContent.trim() && !intro.querySelector('img,video,iframe')) intro.remove();
            this.append(output);
          }
        }
        this.events = new AbortController();
        this.revealAnchor = () => {
          let id;
          try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
          if (!id) return;
          const target = document.getElementById(id);
          if (!target || !this.contains(target)) return;
          for (let parent = target; parent && parent !== this; parent = parent.parentElement) {
            if (parent.tagName === 'DETAILS') parent.open = true;
          }
        };
        window.addEventListener('hashchange', this.revealAnchor, { signal: this.events.signal });
        this.addEventListener('toggle', () => {
          this.dispatchEvent(new CustomEvent('theme:form:sticky', { bubbles: true, detail: { element: 'accordion' } }));
        }, { capture: true, signal: this.events.signal });
        this.revealAnchor();
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
